import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: "dataFilter",
    pure: false
})

export class DataFilterPipe implements PipeTransform {

    transform(array: any[], query?: any, coloumn?:  string): any {
        if (query  && (typeof query === 'string')) {
          return _.filter(array, row => row[coloumn].indexOf(query) > -1);
        }
      if (query && (typeof query === 'object')) {
        return _.filter(array, ((row) => {
          const filters: string[]  = Object.keys(query);
          return  filters.every((filter) =>   row[filter].indexOf(query[filter]) > -1
          ) ;
        }));
      }
        return array;
    }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/shared/elements/data-filter.pipe.ts